import { Component } from '@angular/core';
import { UnloadCleanupService } from './services/unload-cleanup.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Web Rental';
  constructor(private unloadService: UnloadCleanupService){}
}
